<template>
  <div class="select-region">
    <van-popup
      v-model="showPopup"
      position="bottom"
      :close-on-popstate="true"
      @click-overlay="onCancel"
    >
      <van-picker
        show-toolbar
        :columns="columns"
        :loading="loading"
        @change="onChange"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { commonFindCityDistrict } from '@/api/assist-operation'
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    pageType: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  data() {
    return {
      loading: true,
      provinceList: [],
      cityList: [],
      form: {
        bankCardProvince: ''
      },
      columns: [
        {
          values: [],
          defaultIndex: 0
        },
        {
          values: [],
          defaultIndex: 0
        },
        {
          values: [],
          defaultIndex: 0
        }
      ],
      showPopup: this.show
    }
  },
  watch: {
    show(newVal) {
      console.log('newVal', newVal, '调了')
      this.showPopup = newVal
      if (newVal) {
        this.columns = [
          {
            values: [],
            defaultIndex: 0
          },
          {
            values: [],
            defaultIndex: 0
          },
          {
            values: [],
            defaultIndex: 0
          }
        ]
        this.findRegion('', 'country')
      }
    }
  },
  methods: {
    // 选择省市区接口
    findRegion(name, type) {
      let params = {
        name: name,
        type: type
      }
      console.log('type', type, type === 'country')
      commonFindCityDistrict(params).then(res => {
        console.log('res', res)
        let values = []
        if (type === 'country') {
          res.forEach(item => {
            values.push({
              text: item.name,
              code: item.code
            })
          })
          this.columns[0].values = values
          this.findRegion(res[0].name, 'province')
        }
        if (type === 'province') {
          res.forEach(item => {
            values.push({
              text: item.name,
              code: item.code
            })
          })
          this.columns[1].values = values
          this.findRegion(res[0].name, 'city')
        }
        if (type === 'city') {
          res.forEach(item => {
            values.push({
              text: item.name,
              code: item.code
            })
          })
          this.columns[2].values = values
          this.loading = false
        }
      })
    },
    onChange(picker, values, index) {
      // 设置指定列的值
      this.loading = true
      const { text } = values
      console.log('event.detail', values, text)
      if (index === 0) {
        console.log('滑动了省')
        this.findRegion(values[0].text, 'province')
      }
      if (index === 1) {
        console.log('滑动了市')
        this.findRegion(values[1].text, 'city')
      }
      if (index === 2) {
        console.log('滑动了区')
        this.loading = false
      }
      // picker.setColumnValues(1, ['市2'])
    },
    onCancel() {
      if (this.loading) return
      this.$emit('close')
    },
    onConfirm(values) {
      if (this.loading) return
      let selectedRegionStr = `${values[0].text},${values[1].text},${values[2].text} `
      this.$emit('confirm', values, selectedRegionStr)
      this.onCancel()
    }
  }
}
</script>

<style scoped lang="less">
.select-region {
  .content {
    height: 100%;
    box-sizing: border-box;
    .header {
      height: 108px;
      font-size: 34px;
      font-weight: 500;
      color: #1a1a1a;
      display: flex;
      align-items: center;
      padding: 30px 36px;
      box-sizing: border-box;
      .close {
        width: 44px;
        height: 44px;
        margin-left: auto;
      }
    }
    .select-result {
      height: 82px;
      padding: 20px 36px;
      display: flex;
      align-items: center;
      font-size: 32px;
      color: #000;
      box-sizing: border-box;
      border-bottom: 1px solid #f0f0f0;
      .result {
        display: flex;
        align-items: center;
        margin-right: 54px;
        color: #000;
        .dot {
          width: 10px;
          height: 10px;
          background: #ff3934;
          border-radius: 10px;
          margin-right: 12px;
        }
      }
      text {
        color: #ff3934;
      }
    }
    .list {
      padding: 30px 36px;
      height: calc(100% - 190px);
      box-sizing: border-box;
      .item {
        font-size: 30px;
        color: #333333;
        height: 96px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #f0f0f0;
        &:active {
          background-color: #fafafa;
        }
      }
    }
  }
}
</style>
